import { BaseEntity } from 'src/app/entity/base-entity';
import { ContactDto } from 'src/app/entity/contactDto';

export class AddressDto extends BaseEntity {
  id: number;
  idUnitel: number;
  street: string;
  city: string;
  postalCode: string;
  country: string;
  website: string;

  contact: ContactDto;
}
